<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="sysWorkCalendarViewInfo"
                        :filter_language="['Cd_status']"
                        :filter_date="['First_Date','End_Date']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column show-overflow-tooltip prop="Cd_Code" :label="$t('getapi[3314]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="First_Date" :label="$t('getapi[4042]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="End_Date" :label="$t('getapi[4062]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Cd_status" :label="$t('getapi[552]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_person" :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_person" :label="$t('getapi[4043]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_time" :label="$t('getapi[4044]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <div>
                    <el-button type="primary" size="mini" @click="calendarExtend">{{$t('getapi[7023]')}}</el-button>
                    <el-button type="primary" size="mini" @click="getConfigShift">{{$t('getapi[4079]')}}</el-button>
                    <el-button type="primary" size="mini" @click="audit(1)" :disabled="code.cd_status == '有效'">{{$t('getapi[3607]')}}</el-button>
                    <el-button type="primary" size="mini" @click="audit(0)" :disabled="code.cd_status == '无效'">{{$t('getapi[3598]')}}</el-button>
                </div>
                <div>
                    <table>
                        <tr>
                            <td style="width:70px">
                                <span>{{$t('getapi[3314]')}}</span>
                            </td>
                            <td style="width:150px">
                                {{dataDetail.cd_code}}
                            </td>
                            <td colspan="2">
                                <div style="display: flex">
                                    <el-input v-model="dataDetail.year" type="number" autocomplete="off" title="" style="width:100px" @change="changeDate" @mousewheel.native.prevent @DOMMouseScroll.native.prevent></el-input>
                                    <span style="padding-top: 5px">{{$t('getapi[2484]')}}</span>
                                    <el-select filterable v-model="dataDetail.month" size="mini" style="width:100px" @change="changeDate">
                                        <el-option key="1" :label="$t('getapi[1986]')" :value=1></el-option>
                                        <el-option key="2" :label="$t('getapi[1987]')" :value=2></el-option>
                                        <el-option key="3" :label="$t('getapi[1988]')" :value=3></el-option>
                                        <el-option key="4" :label="$t('getapi[1989]')" :value=4></el-option>
                                        <el-option key="5" :label="$t('getapi[1990]')" :value=5></el-option>
                                        <el-option key="6" :label="$t('getapi[1991]')" :value=6></el-option>
                                        <el-option key="7" :label="$t('getapi[1992]')" :value=7></el-option>
                                        <el-option key="8" :label="$t('getapi[1993]')" :value=8></el-option>
                                        <el-option key="9" :label="$t('getapi[1994]')" :value=9></el-option>
                                        <el-option key="10" :label="$t('getapi[1995]')" :value=10></el-option>
                                        <el-option key="11" :label="$t('getapi[1996]')" :value=11></el-option>
                                        <el-option key="12" :label="$t('getapi[1997]')" :value=12></el-option>
                                    </el-select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[4042]')}}</span>
                            </td>
                            <td>
                                {{dataDetail.first_date}}
                            </td>
                            <td style="width:70px">
                                <span>{{$t('getapi[3327]')}}</span>
                            </td>
                            <td>
                                {{dataDetail.end_date}}
                            </td>
                        </tr>
                    </table>
                    <el-calendar v-model="selectdate">
                        <template
                                slot="dateCell"
                                slot-scope="{date, data}">
                            <div style="position: relative;text-align: center;height:100%">
                                <span style="font-size: 20px">{{data.day.split('-').slice(2)[0]}}</span>
                                <div v-for="item in calendardata"  v-bind:key="item.cd_date">
                                    <div v-if="data.day.split('-').slice(1)[0] == item.month && data.day.split('-').slice(0)[0] == item.year">
                                        <div style="font-size: 12px;margin-top: 2px;position: relative;z-index:9" v-if="data.day.split('-').slice(2)[0] == item.lunar.solarDay" class="lunar">
                                            <span v-if="item.lunar.festival" >
                                                {{item.lunar.festival}}
                                            </span>
                                            <span v-else>
                                                {{item.lunar.dayDisplay}}
                                            </span>
                                        </div>
                                        <div @dblclick="exchange(item)" v-if="data.day.split('-').slice(2)[0] == item.day && item.day_status == 1" class="work" style="width:100%;position:absolute;top:0;left:0;height:100%">
                                            <span style="font-size: 20px" @dblclick="exchange(item)">{{data.day.split('-').slice(2)[0]}}</span><br>
                                        </div>
                                        <div @dblclick="exchange(item)" v-if="data.day.split('-').slice(2)[0] == item.day && item.day_status != 1" class="off" style="width:100%;position:absolute;top:0;left:0;height:100%">
                                            <span style="font-size: 20px" @dblclick="exchange(item)">{{data.day.split('-').slice(2)[0]}}</span><br>
                                        </div>
                                        <div style="margin-top: 10px;position: relative;top:25%">
                                            <el-button size="mini" v-if="data.day.split('-').slice(2)[0] == item.day && data.isSelected" @click="getDayShift(date)">{{$t('getapi[4081]')}}</el-button>
                                            <el-button size="mini" v-if="data.day.split('-').slice(2)[0] == item.day && data.isSelected" @click="addNote(date)" style="margin-left: 0">{{$t('getapi[4080]')}}</el-button>
                                            <!--<el-button size="mini" v-if="data.day.split('-').slice(2)[0] == item.day && data.isSelected" @click="exchange(item)">切换</el-button>-->
                                        </div>
                                    </div>
                                    <div v-else></div>
                                </div>
                            </div>
                        </template>
                    </el-calendar>
                    <div>
                        <tr>
                            <td style="width:50px">{{$t('getapi[4070]')}}</td>
                            <td style="width:50px">{{$t('getapi[4049]')}}</td>
                            <td style="width:50px"><div style="width:30px;height:10px" class="off"></div></td>
                            <td style="width:50px">{{$t('getapi[4050]')}}</td>
                            <td style="width:50px"><div style="width:30px;height:10px" class="work"></div></td>
                        </tr>
                    </div>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>

        <serce :isVisible="isVisible" queryData="sysWorkCalendarViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[3981]')" queryData="sysWorkCalendarViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :title="$t('getapi[4060]')" :visible.sync="isShowAdd" width="30%">
            <table>
                <tr>
                    <td>
                        <span>{{$t('getapi[3314]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="addDetail.cd_code"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[4042]')}}</span>
                    </td>
                    <td>
                        <el-date-picker v-model="addDetail.s_date" type="date" size="mini"></el-date-picker>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[4062]')}}</span>
                    </td>
                    <td>
                        <el-date-picker v-model="addDetail.e_date" type="date" size="mini"></el-date-picker>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[4061]')}}</span>
                    </td>
                    <td>
                        <el-select filterable v-model="addDetail.template" size="mini" :disabled="true">
                            <el-option v-for="item in templateArr" :key="item.Name" :label="item.Name" :value="item.Name"></el-option>
                        </el-select>
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button  @click="isShowAdd = false" size="mini">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmAdd" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :title="$t('getapi[4476]')" :visible.sync="isShowDayShift" width="30%">
            <table>
                <tr>
                    <td>
                        <span>{{$t('getapi[4053]')}}</span>
                    </td>
                    <td>
                        {{dataDayShift.date}}
                    </td>
                    <td>
                        <span>{{$t('getapi[4089]')}}</span>
                    </td>
                    <td>
                        {{dataDayShift.day_code}}
                    </td>
                </tr>
            </table>
            <el-table
                    :data="dataDayShift.list"
                    ref="singleTable"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    size="mini"
                    :height="400"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="Shift_period_name" :label="$t('getapi[4091]')"></el-table-column>
                <el-table-column prop="Start_Time" :label="$t('getapi[4056]')">
                    <template slot-scope="scope">
                        <el-date-picker v-model="scope.row.Start_Time" type="datetime"
                                        format="HH:mm" :readonly="true" class="readO" style="width:100%"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column prop="End_Time" :label="$t('getapi[4057]')">
                    <template slot-scope="scope">
                        <el-date-picker v-model="scope.row.End_Time" type="datetime"
                                        format="HH:mm" :readonly="true" class="readO" style="width:100%"></el-date-picker>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button  @click="isShowDayShift = false" size="mini">{{$t('getapi[6]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :title="$t('getapi[4080]')" :visible.sync="isShowNote" width="30%" :close-on-click-modal="false">
            <el-input type="textarea" v-model="note"></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button  @click="isShowNote = false" size="mini">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmAddNote" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :title="$t('getapi[4079]')" :visible.sync="isShowConfigShift" width="30%">
            <table>
                <tr>
                    <td>
                        <span>{{$t('getapi[4042]')}}</span>
                    </td>
                    <td>
                        <el-date-picker
                                        v-model="dataConfigShift.s_date"
                                        clear-icon
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        size="mini"
                                        style="width:100%"
                                ></el-date-picker>

                        <!-- <el-date-picker v-model="dataConfigShift.s_date" type="date"></el-date-picker> -->
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[4062]')}}</span>
                    </td>
                    <td>
                        <el-date-picker
                                        v-model="dataConfigShift.e_date"
                                        clear-icon
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        size="mini"
                                        style="width:100%"
                                ></el-date-picker>

                        <!-- <el-date-picker v-model="dataConfigShift.e_date" type="date"></el-date-picker> -->
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[4096]')}}</span>
                    </td>
                    <td>
                        <el-input
                                v-model="dataConfigShift.shift_code"
                                type="text"
                                readonly
                                class="mcolor"
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectShiftCode()"></i>
                        </el-input>
                    </td>
                </tr>
            </table>
            <el-table
                    :data="dataConfigShift.list"
                    ref="singleTable"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    size="mini"
                    :height="400"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="Shift_period_name" :label="$t('getapi[4091]')"></el-table-column>
                <el-table-column prop="Start_Time" :label="$t('getapi[4056]')">
                    <template slot-scope="scope">
                        <el-date-picker v-model="scope.row.Start_Time" type="datetime"
                                        format="HH:mm" :readonly="true" class="readO" style="width:100%"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column prop="End_Time" :label="$t('getapi[4057]')">
                    <template slot-scope="scope">
                        <el-date-picker v-model="scope.row.End_Time" type="datetime"
                                        format="HH:mm" :readonly="true" class="readO" style="width:100%"></el-date-picker>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button  @click="isShowConfigShift = false" size="mini">{{$t('getapi[6]')}}</el-button>
                <el-button type="primary" @click="confirmConfigShift" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :title="$t('getapi[7023]')" :visible.sync="isShowExtend" width="30%">
            <table>
                <tr>
                    <td>
                        <span>{{$t('getapi[3314]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataExtend.cd_code" :readonly="true" class="readO"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[4062]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataExtend.Tyear" maxlength="4" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                      <!--  <el-date-picker v-model="dataExtend.Tyear" type="datetime"></el-date-picker>-->
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button  @click="isShowExtend = false" size="mini">{{$t('getapi[6]')}}</el-button>
                <el-button type="primary" @click="confirmCalendarExtend" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/WH/GetShiftPopupDataList'" @callback="getShiftCode" ref="shiftcode"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_calendarview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_calendarview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowAdd: false,
                addDetail:{

                },
                code: {},// key,一览上获取的数据
                dataDetail:{},
                selectdate: new Date(), //日历显示的日期
                calendardata: [], //日历明细数据
                templateArr: [], //日历模板数组

                isShowDayShift: false, //是否显示班次信息
                dataDayShift:{},//班次信息

                isShowNote: false,
                dataNote: {
                    cd_code: '',
                    cd_date: '',
                    Day_desc: '',
                },
                note: '',
                isShowConfigShift: false, //班次设置向导
                dataConfigShift:{},

                isShowExtend: false, //日历扩展
                dataExtend:{},
                scrollTop:0,
            };
        },
        created: function(){
            let that = this
            this.$nextTick(() => {
                // 点击前一个月
                let prevBtn = document.querySelector(
                    '.el-calendar__button-group .el-button-group>button:nth-child(1)');
                prevBtn.addEventListener('click', () => {
                    if(that.dataDetail.month == 1){
                        that.dataDetail.year = that.dataDetail.year - 1
                        that.dataDetail.month = 12
                    } else {
                        that.dataDetail.month = that.dataDetail.month - 1
                    }
                    that.getDetail(that.code.cd_code, that.dataDetail.year, that.dataDetail.month)
                })
            })

            this.$nextTick(() => {
                // 点击当月
                let prevBtn = document.querySelector(
                    '.el-calendar__button-group .el-button-group>button:nth-child(2)');
                prevBtn.addEventListener('click', () => {
                    that.dataDetail.year = new Date().getFullYear()
                    that.dataDetail.month = new Date().getMonth() + 1
                    that.getDetail(that.code.cd_code, that.dataDetail.year, that.dataDetail.month)
                })
            })

            this.$nextTick(() => {
                // 点击后一个月
                let prevBtn = document.querySelector(
                    '.el-calendar__button-group .el-button-group>button:last-child');
                prevBtn.addEventListener('click', () => {
                    if(that.dataDetail.month == 12){
                        that.dataDetail.year = that.dataDetail.year + 1
                        that.dataDetail.month = 1
                    } else {
                        that.dataDetail.month = that.dataDetail.month + 1
                    }
                    that.getDetail(that.code.cd_code, that.dataDetail.year, that.dataDetail.month)
                })
            })

            this.$nextTick(() => {
                let btn1 = document.querySelector('.el-calendar-table thead th:nth-child(1)')
                btn1.innerText = that.$t('getapi[6289]')
                btn1.addEventListener('dblclick', ()=>{
                    if(that.calendardata.length == 0){
                        return
                    }
                    let arr = []
                    for(let i = 0;i<that.calendardata.length;i++){
                        if(new Date(that.calendardata[i].cd_date).getDay() == 1){
                            if(that.calendardata[i].day_status == 1){
                                that.calendardata[i].day_status = 0
                            } else {
                                that.calendardata[i].day_status = 1
                            }
                            arr = [...arr,{
                                cd_date: that.calendardata[i].cd_date,
                                day_status:  that.calendardata[i].day_status
                            }]
                        }
                    }
                    that.changeDaysStatus(arr)
                })
                let btn2 = document.querySelector('.el-calendar-table thead th:nth-child(2)')
                btn2.innerText = that.$t('getapi[6290]')
                btn2.addEventListener('dblclick', ()=>{
                    if(that.calendardata.length == 0){
                        return
                    }
                    let arr = []
                    for(let i = 0;i<that.calendardata.length;i++){
                        if(new Date(that.calendardata[i].cd_date).getDay() == 2){
                            if(that.calendardata[i].day_status == 1){
                                that.calendardata[i].day_status = 0
                            } else {
                                that.calendardata[i].day_status = 1
                            }
                            arr = [...arr,{
                                cd_date: that.calendardata[i].cd_date,
                                day_status:  that.calendardata[i].day_status
                            }]
                        }
                    }
                    that.changeDaysStatus(arr)
                })
                let btn3 = document.querySelector('.el-calendar-table thead th:nth-child(3)')
                btn3.innerText = that.$t('getapi[6291]')
                btn3.addEventListener('dblclick', ()=>{
                    if(that.calendardata.length == 0){
                        return
                    }
                    let arr = []
                    for(let i = 0;i<that.calendardata.length;i++){
                        if(new Date(that.calendardata[i].cd_date).getDay() == 3){
                            if(that.calendardata[i].day_status == 1){
                                that.calendardata[i].day_status = 0
                            } else {
                                that.calendardata[i].day_status = 1
                            }
                            arr = [...arr,{
                                cd_date: that.calendardata[i].cd_date,
                                day_status:  that.calendardata[i].day_status
                            }]
                        }
                    }
                    that.changeDaysStatus(arr)
                })
                let btn4 = document.querySelector('.el-calendar-table thead th:nth-child(4)')
                btn4.innerText = that.$t('getapi[6292]')
                btn4.addEventListener('dblclick', ()=>{
                    if(that.calendardata.length == 0){
                        return
                    }
                    let arr = []
                    for(let i = 0;i<that.calendardata.length;i++){
                        if(new Date(that.calendardata[i].cd_date).getDay() == 4){
                            if(that.calendardata[i].day_status == 1){
                                that.calendardata[i].day_status = 0
                            } else {
                                that.calendardata[i].day_status = 1
                            }
                            arr = [...arr,{
                                cd_date: that.calendardata[i].cd_date,
                                day_status:  that.calendardata[i].day_status
                            }]
                        }
                    }
                    that.changeDaysStatus(arr)
                })
                let btn5 = document.querySelector('.el-calendar-table thead th:nth-child(5)')
                btn5.innerText = that.$t('getapi[6293]')
                btn5.addEventListener('dblclick', ()=>{
                    if(that.calendardata.length == 0){
                        return
                    }
                    let arr = []
                    for(let i = 0;i<that.calendardata.length;i++){
                        if(new Date(that.calendardata[i].cd_date).getDay() == 5){
                            if(that.calendardata[i].day_status == 1){
                                that.calendardata[i].day_status = 0
                            } else {
                                that.calendardata[i].day_status = 1
                            }
                            arr = [...arr,{
                                cd_date: that.calendardata[i].cd_date,
                                day_status:  that.calendardata[i].day_status
                            }]
                        }
                    }
                    that.changeDaysStatus(arr)
                })
                let btn6 = document.querySelector('.el-calendar-table thead th:nth-child(6)')
                btn6.innerText = that.$t('getapi[6294]')
                btn6.addEventListener('dblclick', ()=>{
                    if(that.calendardata.length == 0){
                        return
                    }
                    let arr = []
                    for(let i = 0;i<that.calendardata.length;i++){
                        if(new Date(that.calendardata[i].cd_date).getDay() == 6){
                            if(that.calendardata[i].day_status == 1){
                                that.calendardata[i].day_status = 0
                            } else {
                                that.calendardata[i].day_status = 1
                            }
                            arr = [...arr,{
                                cd_date: that.calendardata[i].cd_date,
                                day_status:  that.calendardata[i].day_status
                            }]
                        }
                    }
                    that.changeDaysStatus(arr)
                })
                let btn7 = document.querySelector('.el-calendar-table thead th:nth-child(7)')
                btn7.innerText = that.$t('getapi[6295]')
                btn7.addEventListener('dblclick', ()=>{
                    if(that.calendardata.length == 0){
                        return
                    }
                    let arr = []
                    for(let i = 0;i<that.calendardata.length;i++){
                        if(new Date(that.calendardata[i].cd_date).getDay() == 0){
                            if(that.calendardata[i].day_status == 1){
                                that.calendardata[i].day_status = 0
                            } else {
                                that.calendardata[i].day_status = 1
                            }
                            arr = [...arr,{
                                cd_date: that.calendardata[i].cd_date,
                                day_status:  that.calendardata[i].day_status
                            }]
                        }
                    }
                    that.changeDaysStatus(arr)
                })
            })
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            that.$limits.dragControllerDiv1();
            that.getModel()
            that.authority()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('sysWorkCalendarViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3981]"),this.$t("getapi[27]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv2', 166, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                if (that.$limits.authority('plv2', 166, 1) == 2) {
                    if (that.$limits.authority('plv3', 166,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 166,1) == 1) {
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 166, 1) == 2) {
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                    }
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            // 获取某天属于星期几
            getWeek(date){
                let that = this
            },
            getModel(){
                let that = this
                that.$http.urlpost('/Basic/WH/GetCalendarDropDown', '', function (res) {
                    if (res.Success == 1) {
                        console.log(1)
                        let data = res.DataContent
                        if(data.length > 0){
                            for(let i=0;i<data.length;i++){
                                that.templateArr = [...that.templateArr,{
                                    Name: data[i].Cd_Code
                                }]
                            }
                        }
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_calendarview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'sysWorkCalendarViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Basic/WH/GetCalendarList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.code.cd_code == row.Cd_Code){
                    return
                }
                that.code = {
                    cd_code: row.Cd_Code,
                    cd_status: row.Cd_status,
                    first_date: row.First_Date,
                    end_date: row.End_Date,
                }
                that.dataDetail = {
                    cd_code: that.code.cd_code,
                    first_date: that.code.first_date,
                    end_date: that.code.end_date,
                    year: new Date(that.code.first_date).getFullYear(),
                    month:new Date(that.code.first_date).getMonth() + 1,
                }
                let date = new Date(that.code.first_date);
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                if(row.Cd_status == '无效'){
                    that.getDetail(that.code.cd_code, year, month)
                } else {
                    that.getDetail(that.code.cd_code, new Date().getFullYear(), new Date().getMonth() + 1)
                }
            },
            //改变日期
            changeDate(){
                let that = this
                that.getDetail(that.code.cd_code, that.dataDetail.year, that.dataDetail.month)
            },
            // 获取详情数据
            getDetail(cd_code,year,month) {
                let that = this
                let parm = {
                    cd_code: cd_code,
                    tyear: year,
                    tmonth: month
                }
                that.$http.urlpost('/Basic/WH/GetDayStatsu', parm, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent
                        if(data.length > 0){
                            that.calendardata = []
                            that.selectdate = null
                            const today = new Date()
                            const todayYear = today.getFullYear()
                            const todayMonth = today.getMonth()
                            const todayDay = today.getDate()
                            for(let i = 0;i<data.length;i++){
                                that.calendardata = [...that.calendardata,{
                                    cd_date: data[i].cd_date,
                                    year: new Date(data[i].cd_date).getFullYear(),
                                    month:new Date(data[i].cd_date).getMonth() + 1,
                                    day: new Date(data[i].cd_date).getDate(),
                                    day_status: data[i].day_status,
                                    lunar: that.$lunarcalendar.getDetailedLunar(data[i].cd_date)
                                }]
                                const itemDate = new Date(data[i].cd_date)
                                if(itemDate.getFullYear() === todayYear &&
                                    itemDate.getMonth() === todayMonth &&
                                    itemDate.getDate() === todayDay){
                                    that.selectdate = itemDate
                                }
                            }
                            console.log(that.calendardata)
                        }
                    }
                });
            },
            // 新增
            add() {
                let that = this;
                that.$http.urlpost('/Basic/WH/GetCdCode', '', function (res) {
                    if (res.Success == 1) {
                        that.isShowAdd = true
                        that.addDetail = {
                            cd_code: res.DataContent,
                            s_date: new Date().getFullYear()+'-'+'01'+'-'+'01',
                            e_date: new Date().getFullYear()+'-'+'12'+'-'+'31',
                            template: "自然日历"
                        }
                    }
                });
            },
            confirmAdd(){
                let that = this;
                let parm = that.addDetail
                that.$http.urlpost('/Basic/WH/CreateCalendar', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.isShowAdd = false
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView()
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Basic/WH/GetCalendarListToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "sysWorkCalendarViewInfo",
                    fromname: that.$t('getapi[3981]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 审核
            audit(val){
                let that = this
                let parm = {
                    cd_code: that.code.cd_code,
                    cd_status: val
                }
                that.$http.urlpost('/Basic/WH/ChangeCalendarStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                        if(val == 1){
                            that.code.cd_status = '有效'
                        } else {
                            that.code.cd_status = '无效'
                        }
                    }
                });
            },
            // 查看班次
            getDayShift(date){
                let that = this
                console.log(date)
                let parm = {
                    cd_code: that.code.cd_code,
                    cd_date: date
                }
                that.$http.urlpost('/Basic/WH/GetDayShift', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowDayShift = true
                        if(res.DataContent.length > 0){
                            that.dataDayShift = {
                                date: new Date(date).getFullYear() + '-' + (parseInt(new Date(date).getMonth()) + 1) + '-' + new Date(date).getDate(),
                                day_code: res.DataContent[0].Work_Day_Code,
                                list: res.DataContent
                            }
                        }
                    }
                });
            },
            // 取得描述
            addNote(date){
                let that = this
                that.dataNote = {
                    cd_code: that.code.cd_code,
                    cd_date: date,
                    Day_desc: '',
                }
                let parm = {
                    cd_code: that.code.cd_code,
                    cd_date: date
                }
                that.$http.urlpost('/Basic/WH/GetNote', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowNote = true
                        that.note = res.DataContent
                    }
                });
            },
            confirmAddNote(){
                let that = this
                that.dataNote.Day_desc = that.note
                let parm = that.dataNote
                that.$http.urlpost('/Basic/WH/SaveNote', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowNote = false
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            // 班次设置向导
            getConfigShift(){
                let that = this
                that.dataConfigShift = {
                    cd_code: that.code.cd_code,
                    s_date: that.code.first_date,
                    e_date: that.code.end_date,
                    shift_code: '',
                    list: [],
                }
                that.isShowConfigShift = true
            },
            // 班次设置向导-设置
            confirmConfigShift(){
                let that = this
                let parm = that.dataConfigShift
                that.$http.urlpost('/Basic/WH/ConfigShift', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowConfigShift = false
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            //切换
            exchange(val){
                let that = this
                if(val.day_status == 1){
                    val.day_status = 0
                } else {
                    val.day_status = 1
                }
                let arr = []
                arr.push({
                    cd_date: val.cd_date,
                    day_status: val.day_status
                })
                that.changeDaysStatus(arr)
            },
            changeDaysStatus(arr){
                let that = this
                let parm = {
                    cd_code: that.dataDetail.cd_code,
                    ls: arr
                }
                that.$http.urlpost('/Basic/WH/ChangeDaysStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            selectShiftCode(){
                let that = this;
                that.$refs.shiftcode.clearInput(true);
            },
            getShiftCode(val){
                let that = this;
                console.log(val)
                that.dataConfigShift.shift_code = val.Work_Day_Code;
                let parm = {
                    shift_code: val.Work_Day_Code
                }
                that.$http.urlpost('/Basic/WH/GetShiftInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataConfigShift.list = res.DataContent.line
                    }
                });
            },
            calendarExtend(){
                let that = this
                that.isShowExtend = true
                that.dataExtend = {
                    cd_code: that.code.cd_code,
                    Tyear: ''
                }
            },
            confirmCalendarExtend(){
                let that = this
                let parm = that.dataExtend
                that.$http.urlpost('/Basic/WH/CalendarExtend', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.isShowExtend = false
                        that.getView()
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .off {
        background: #ff9c1c;
    }
    .work{
        background: #a8fff7;
    }
    /deep/.el-calendar-table {
        width: 100%;
        height: 100%;
        &:not(.is-range) {
            //使不是本月的日期不可点击，不会跳转到其他月份
            td.next {
                pointer-events: none;
            }
            td.prev {
                pointer-events: none;
            }
        }
    }
    /deep/.el-calendar__header{
        font-size: 20px;
        .el-calendar__title{
            margin-left: 45%;
        }
    }
    /deep/.el-calendar-table thead th{
        text-align: center;
    }
    .lunar{
        color:#666
    }
    /deep/.el-calendar-table td.is-selected {
        background-color: #dc0202;
        color:#FFFFFF;
        .lunar{
            color:#FFFFFF
        }
        .offfont {
            color: #FFFFFF;
        }
        .work {
            background: none;
        }
        .off{
            background: none;
        }
    }
    /deep/ .el-calendar-table .el-calendar-day:hover {
        background: none;
    }
</style>
